import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageDialogDataInterface } from './message-dialog-data.interface';

@Component({
  selector: 'ui-message-dialog',
  templateUrl: './message-dialog.component.html',
  styleUrls: ['./message-dialog.component.scss', '../dialog.component.scss'],
})
export class MessageDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<MessageDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MessageDialogDataInterface
  ) {}

  onClickClose(): void {
    this.dialogRef.close(false);
  }
}
